import angular from 'angular';

/* @ngInject */
export default function CERepeatDirective() {
    return {
        priority: 1000,
        terminal: true,
        $$tlb: true,

        link: function ($scope, $element, $attr) {
            var clickFn = $scope.$eval($attr.clickFn);
            var parentDom = $element.parent();
            var parent = $scope.$eval($attr.parent);

            // Helper function to escape HTML entities
            // In order to solve https://kemetelectronics.atlassian.net/browse/IST-366
            // The original CERepeatDirective used li.innerHTML to set the content of the <li> element,
            // which treated the value as HTML and caused issues when special characters like '<' and '>' were present.
            // To resolve this, we switched to using the innerText property to insert the value as plain text,
            // avoiding HTML parsing and preserving the original formatting.
            function escapeHTML(value) {
                const element = document.createElement('div');
                element.innerText = value;
                return element.innerHTML;
            }


            $scope.$watchCollection($attr.ceRepeat, function ngRepeatAction(collection) {
                parent.loadingDom = true;
                angular.element(parentDom).empty();
                $scope.populateByFrag(parentDom, collection);
                parent.loadingDom = false;
            });

            // Populate DOM by DocumentFragment.
            $scope.populateByFrag = function (parentDom, collection) {
                let i;
                const docFrag = document.createDocumentFragment();
                for (i = 0; i < collection.length; ++i) {
                    if (collection[i].show !== undefined && !collection[i].show) {
                        continue;
                    }
                    const li = document.createElement('li');
                    // In order to solve https://kemetelectronics.atlassian.net/browse/IST-366
                    li.innerHTML = escapeHTML(collection[i][$attr.displayProperty]);
                    if (parent.query && parent.query.selectedFormattedValues
                        && parent.query.selectedFormattedValues.indexOf(collection[i]) !== -1) {
                        li.setAttribute('class', 'currently-selected');
                    }
                    angular.element(li).data('index', i);
                    angular.element(li).bind('click', function (event) {
                        clickFn(collection[angular.element(event.target).data('index')], parent);
                    });
                    docFrag.appendChild(li);
                }
                parentDom.append(docFrag);
            };

            $scope.$on('$destroy', function clearDom() {
                angular.element(parentDom).empty();
            });
        }
    };
}
